import { useEffect } from "react";
import Web3 from "web3";
const WEI = ({ value, arg }) => {
  return <>{Web3.utils.fromWei(value, arg)}</>;
};

export default WEI;
